import { useContext } from 'react';

import { MobXProviderContext } from 'mobx-react';
import { MobxStore } from '@/mobx/types';

// 通过mobx key获取相对应的state
export const useMobx = <T extends keyof MobxStore>(scopes: T[]) => {
  // mobx store
  const mobxStore = useContext(MobXProviderContext) as MobxStore;

  const scopeData: Pick<MobxStore, T> = Object.create({});

  // mobx scope data
  scopes.reduce<Pick<MobxStore, T>>((prevScopeData, mobxKey) => {
    prevScopeData[mobxKey] = mobxStore[mobxKey];
    return prevScopeData;
  }, scopeData);

  return scopeData;
};
